<div class="loader dash-loader text-center"><img src="assets/images/site/workstream-creation/submit-loader.svg" alt="Loader" /></div>